<template>
    <div class="messageWrap">
        <div class="title">
            此处添加的手机号码是用于在生产加工模块中有生产商或者品牌商提交认证时提示进行审核，提示内容实例：
            <p class="des">
                您好，有生产商/品牌商于今日16:10提交身份认证申请，请尽快进行审核，特此通知。
            </p>
        </div>
        <div class="addPhoneWrap">
            通知接收手机号：
            <input type="text" placeholder="请输入要添加的手机号" v-model="phoneInput">
            <el-button type="primary" size="mini" @click="addPhone">添加</el-button>
            <div class="phoneListWrap">
                <p class="phoneTitle">发送通知的手机号列表：</p>
                <ul class="listUl">
                    <li v-for="(list,index)  in phoneArr" class="listItem">
                        <span class="phone"> <span class="indexNum">{{index+1}}、</span> {{list}}</span>

                        <el-button type="primary" size="mini" @click='deletePhone(index)'><i class="el-icon-delete"></i></el-button>
                    </li>
                </ul>
            </div>



        </div>



    </div>
</template>

<script>
    // import {json,wordData,utils} from '@/common/common.js'
    import {
        api,
        ajaxPost
    } from '@/common/request.js'
    export default {
        name: 'HelloWorld',
        data() {
            return {
                sqlSavePhoneStr: '',
                phoneInput: '',
                phoneArr: [],
            }
        },
        methods: {
            refreshPage() {
              this.phoneArr = []
              this.getInfo()

            },
            submitPhone(arrArg) {
                let _this = this
                let phoneStr = arrArg.join(",")
                let arg = {
                    "showType": "2",
                    "configName": "admin_sms_notice",
                    "configValue": phoneStr,
                }
                ajaxPost('/app/updateConfigInfoByType', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.$message({
                            message: "修改成功",
                            type: 'success',
                            duration: 1500
                        });
                        
                    }
                    _this.refreshPage()
                }, function(res) {
                    _this.refreshPage()
                })


            },
            deletePhone(index) {
                let _this=this
                if(confirm("确认删除吗？")){
                    if (_this.phoneArr.length == 1) {
                        _this.$message({
                            message: "最后一个，不允许删除",
                            type: 'error',
                            duration: 1500
                        });
                    } else {
                        _this.phoneArr.splice(index, 1)
                        _this.submitPhone(this.phoneArr)
                    }
                }
                
                
            },
            addPhone() {
                let _this = this
                let reg = /^1(3|4|5|6|7|8|9)[0-9]{9}$/
                if (!reg.test(_this.phoneInput)) {
                    _this.$message({
                        message: "请输入正确的手机号",
                        type: 'error',
                        duration: 1500
                    });
                }else{
                    let isRepeatPhone=false
                    let repeatId=''
                   _this.phoneArr.forEach(function(item,index){
                       console.log(item)
                       if(item==_this.phoneInput){
                           repeatId=parseInt(index)+1
                           isRepeatPhone=true
                           return false
                       }
                       
                   })
                   if(isRepeatPhone){
                       _this.$message({
                           message: "该手机号已存在，第"+repeatId+'个',
                           type: 'error',
                           duration: 1500
                       });
                   }else{
                       _this.phoneArr.push(_this.phoneInput)
                       _this.submitPhone(_this.phoneArr)
                   }
                    
                }
                // if(reg.test(_this.phoneInput)){
                //     _this.phoneArr.push(_this.phoneInput)
                // }else{
                //     _this.$message({
                //         message: "请输入正确的手机号", 
                //         type: 'error',
                //         duration: 1500
                //     });
                // }
                // 
            },
            getInfo() {
                let _this = this
                let arg = {
                    showType: 2 //1=app首页设置  2=认证短信设置   3=服务费设置
                }
                ajaxPost('/app/showAppConfigInfo', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        if (res.data.config_name == 'admin_sms_notice' && res.data.config_value) {
                            _this.sqlSavePhoneStr = res.data.config_value
                            _this.phoneArr = res.data.config_value.split(",")
                        } else {
                            _this.phoneArr = []
                            _this.$message({
                                message: "暂无手机号",
                                type: 'error',
                                duration: 1500
                            });
                        }
                    }
                }, function(res) {})
            }
        },
        mounted() {
            this.getInfo()

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .messageWrap {

        .indexNum {
            margin-right: 3px;
        }

        padding:10px 20px;

        .title {
            .des {
                font-weight: bold;
                color: royalblue;
            }
        }

        .addPhoneWrap {
            padding: 10px 15px;
            border: 1px solid #ddd;
            margin: 10px 0;
            background: #fff;

            input {
                border-radius: 4px;
                padding: 8px;
                border: 1px solid #aaa;
            }

            .phoneTitle {
                padding: 10px 0;
                font-weight: bold;
            }

            .listUl {
                padding: 10px;

                // max-height: 300px; overflow: scroll;
                .listItem {
                    padding: 10px;

                    // display: inline-block;border:1px solid #aaa; 
                    .phone {
                        display: inline-block;
                        width: 150px;
                        color: slateblue;
                        font-weight: bold;
                    }

                    .deleteIcon {
                        color: #333;
                        cursor: pointer;
                        padding: 5px 7px;
                    }

                    .deleteIcon:hover {
                        background: royalblue;
                        color: #fff;
                    }
                }

                .listItem:hover {
                    background: lightblue;
                }
            }

            .phoneListWrap {
                border: 1px solid #eee;
                background: #eef;
                box-shadow: 0 3px 10px #999;
                padding: 10px;
                margin: 20px 0;
            }


        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/appPage/messageContent.vue